<form [formGroup]="form!">
  <div class="message-receiver-area">
    <span><strong>You</strong> to:</span>
    @if (isHostFeed && moderatedChat) {
      <span class="host-pill">Host</span>
    } @else {
      <mat-select formControlName="receiver" class="message-receiver-select" panelClass="message-receiver-select-panel">
        <mat-option [value]="'all'">All</mat-option>
        @for (user of users; track user) {
          <mat-option [value]="user.userId">
            @if (isUserHost(user) && moderatedChat) {
              (<b>Host</b>) {{ user | formatUserName }}
            } @else {
              {{ user | formatUserName }}
            }
          </mat-option>
        }
      </mat-select>
    }

    @if (isHostFeed && moderatedChat) {
      <span class="message-type blue-text">Host Only</span>
    } @else {
      <span class="message-type">{{ messageType }}</span>
    }
  </div>
  <div class="message-composer">
    <textarea
      data-testid="chat-composer-textarea"
      id="txtAreaChatComposer"
      #messageTextArea
      formControlName="message"
      (focus)="onMessageFocus()"
      (blur)="onMessageBlur()"
      (keydown)="onMessageKeyDown($event)"
    ></textarea>
  </div>
  <div class="message-footer">
    @if (form!.controls.message.errors?.maxlength) {
      <p class="error">Must not exceed {{ form!.controls.message.errors?.maxlength?.requiredLength }} characters</p>
    }
    <div #chatEmojiPickerButton>
      @if (emotes) {
        <button aria-label="Add emoji" type="button" mat-icon-button class="emoji-button" (click)="toggleEmotePicker()">
          <mat-icon class="add-emoji-icon" svgIcon="ADD_EMOJI"></mat-icon>
        </button>
      }
    </div>

    <div #chatEmojiPicker>
      @if (emotes && emotesPickerOpen) {
        <emoji-mart
          (emojiClick)="addEmoji($event)"
          [darkMode]="false"
          [showPreview]="false"
          color="#0c58c6"
          title="Pick your emoji…"
          emoji="grinning"
          [recent]="defaultEmojis"
          set="apple"
        ></emoji-mart>
      }
    </div>

    @if (this.chatService.userIdToReply) {
      <button type="button" mat-flat-button class="cancel-button" (click)="cancelReply()">CANCEL</button>
    }

    <button type="button" mat-flat-button class="send-button" [disabled]="form!.invalid" (click)="sendMessage(true)">
      SEND
    </button>
  </div>
</form>
